import TennisIcon from './TennisIcon'

export default TennisIcon
